// extracted by mini-css-extract-plugin
module.exports = {"suggestion__value":"FormFieldPhoneCode_suggestion__value__1Z6cm","suggestions__container":"FormFieldPhoneCode_suggestions__container__izNzZ"};